import { buildCatalogUrl } from '@/shared/utils/buildCatalogUrl';

export interface BuildCategoryLevelUrlParams {
  level: 'category' | 'subcategory';
  itemSlug: string;
  fullPath: string;
  region?: string;
  category?: string;
  subcategory?: string;
  sort?: string;
}

export const buildCategoryLevelUrl = ({
  level,
  itemSlug,
  fullPath,
  region,
  category,
  subcategory,
  sort,
}: BuildCategoryLevelUrlParams): string => {
  if (!itemSlug) {
    const [path = ''] = fullPath.split('?');
    let cleaned = path;
    if (level === 'category' && category) cleaned = cleaned.replace(`/${category}`, '');
    if (subcategory) cleaned = cleaned.replace(`/${subcategory}`, '');
    return cleaned;
  }

  const head = level === 'category' ? [itemSlug] : [category, itemSlug];
  const tail = sort ? ['sort', sort] : [];
  const segments = region ? ['geo', region, ...head, ...tail] : [...head, ...tail];
  return buildCatalogUrl({ segments });
};
